import useSWR from 'swr';

function addAccessTokenToHeaders(initialHeaders?: Record<string, string>): Record<string, string> {
  const accessToken = localStorage.getItem('accesstoken');
  const refreshToken = localStorage.getItem('refreshtoken');

  if (!accessToken || !refreshToken) {
    throw new Error('Unauthorized');
  }

  const headers: Record<string, string> = initialHeaders ? { ...(initialHeaders as Record<string, string>) } : {};

  if (headers['Content-Type'] === undefined) {
    headers['Content-Type'] = 'application/json';
  }

  headers['accesstoken'] = accessToken;
  headers['refreshtoken'] = refreshToken;

  return headers;
}

// normal fetcher
export const fetcher = async (url: string) => {
  const headers = addAccessTokenToHeaders();
  try {
    const response = await fetch(url, { headers });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
      return;
    }
    return response.json();
  } catch (error) {
    console.error(error);
  }
};

// Custom Hook
export const useCustomSWR = <T,>(url: string, options = {}) => {
  const { data, error, isValidating, mutate } = useSWR<T>(url, fetcher, {
    ...options,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    isValidating,
    mutate,
  };
};
